import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getMaskedCardNumber} from '../../../utils/getMaskedCardNumber';
import CreditCardFooter from '../../molecules/CreditCardFooter';
import ZepzPayinPropTypes from '../../pages/ZepzPayin/zepz-payin.proptypes';
import CreditCardPopup from '../CreditCardPopup';
import {pushAnalyticsEvent} from '../Analytics';
import {getZepzCardLogoUrl} from '../../../utils/getZepzCardLogoUrl';
import {CREDIT_CARD_PAYMENT_METHODS} from '../../../consts';

const ZepzCreditCard = ({
    card,
    translations,
    genericError,
    onRemove,
    isSubmitting,
    onSubmit
}) => {
    const maskedCardNumber = getMaskedCardNumber(card.panSuffix);
    const [isPopupVisible, setPopupVisibility] = useState(false);

    /* TODO: TBD with BE expiry as strings and form of 02/2020 */
    const expiryMonth = `${card?.expiry?.month}`.padStart(2, '0');
    const expiryDate = `${expiryMonth}/${card?.expiry?.year}`;

    const handleClose = () => {
        setPopupVisibility(false);

        pushAnalyticsEvent({
            interactionName: 'card payment interaction',
            cardPaymentAction: 'close saved card cvv modal'
        });
    };

    const showPopup = () => {
        if (!genericError) {
            setPopupVisibility(true);

            pushAnalyticsEvent({
                interactionName: 'card payment interaction',
                cardPaymentAction: 'click on saved card'
            });
        }
    };

    return (
        <li className="centered-div credit-card">
            {!genericError && isPopupVisible && (
                <CreditCardPopup
                    translations={translations}
                    maskedCardNumber={maskedCardNumber}
                    genericError={genericError}
                    isSubmitting={isSubmitting}
                    onClose={handleClose}
                    onSubmit={cvv => onSubmit({cardId: card.id, cvv})}
                    paymentMethod={CREDIT_CARD_PAYMENT_METHODS.ZEPZ}
                />
            )}
            <button
                type="button"
                className="credit-card-front"
                disabled={genericError}
                onClick={showPopup}
            >
                <div className="credit-cart-front-top">
                    <div className="credit-card-chip" />
                    <div className="logo-cc">
                        <img src={getZepzCardLogoUrl(card)} alt={card.scheme} />
                    </div>
                </div>
                <div className="credit-cart-front-middle credit-card-number">
                    {maskedCardNumber}
                </div>
                <div className="credit-cart-front-bottom card-expiration-date">
                    <p>{translations.creditCard.expires}</p>
                    <div className="expiry-date-container">{expiryDate}</div>
                </div>
            </button>
            <CreditCardFooter
                translations={translations}
                genericError={genericError}
                onRemove={() => onRemove(card)}
            />
        </li>
    );
};

ZepzCreditCard.propTypes = {
    card: ZepzPayinPropTypes.Card.isRequired,
    translations: ZepzPayinPropTypes.Translations.isRequired,
    genericError: PropTypes.bool.isRequired,
    onRemove: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default ZepzCreditCard;
